const MAX_PERCENT = 100;

const convertStringToNumber = (str: string) => {
  const number = parseFloat(str.replace(',', '.'));

  return Number.isNaN(number) ? null : number;
};

export const calculatePercentage = (value: string, count: number) => {
  const valueAsNumber = convertStringToNumber(value);

  if (!valueAsNumber) {
    return `${count}%`;
  }

  const percentage = (valueAsNumber / count) * MAX_PERCENT;

  return `${percentage.toFixed(0)}%`;
};
